import Vue from "vue";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { email, maxLength, minLength, required } from "vuelidate/lib/validators";
import { validationMixin } from "vuelidate";
import { directive as onClickaway } from "vue-clickaway";
import deliveryNovaPoshta from "./components/delivery-nova-poshta/index.vue";
import moment from "moment";
import _ from "lodash";
import AdvancedSearch from "vue-advanced-search";
import mainSelect from "../main-select/index.vue";
import privateData from "./components/steps/private-data/index.vue";
import typeDelivery from "./components/steps/type-delivery/index.vue";
import typePayment from "./components/steps/type-payment/index.vue";
import itemInBasket from "./components/item-in-basket/index.vue";
import agentClientData from "./components/steps/agent-client-data/index.vue";
Vue.prototype.moment = moment;

export default {
    name: "thank-you",
    provide() {
        return {
            $v: this.$v,
        };
    },
    mixin: [validationMixin],
    data() {
        return {
            isValidCode: false,
            findClient: [],
            pickedClient: "",
            stage: 1,
            payload: {
                name: "",
                second_name: "",
                last_name: "",
                email: "",
                phone: "",
                delivery: "",
                payment: "",
                city: "",
                street: "",
                house: "",
                flat: "",
                recipient: 1,
                user_comment: "",
                need_confirm: 0,
                town: "",
                department: "",
            },
            options: [],
            agentFlow: false,
            model: null,
            valid: false,
            open: false,
            isShowComment: false,
            isShowOrderInfo: false,
            validationErrors: {},
        };
    },
    validations() {
        if (this.payload.delivery.id === 5) {
            return {
                payload: {
                    name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    second_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    last_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    email: {
                        required,
                        maxLength: maxLength(50),
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(19),
                    },
                    user_comment: {
                        minLength: minLength(5),
                        maxLength: maxLength(300),
                    },
                },
            };
        } else if (this.payload.delivery.id === 1) {
            return {
                payload: {
                    name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    second_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },

                    last_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    email: {
                        required,
                        maxLength: maxLength(50),
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(19),
                    },
                    user_comment: {
                        minLength: minLength(5),
                        maxLength: maxLength(300),
                    },
                },
            };
        } else {
            return {
                payload: {
                    name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    second_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    last_name: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(20),
                    },
                    email: {
                        required,
                        maxLength: maxLength(50),
                        email,
                    },
                    phone: {
                        required,
                        minLength: minLength(19),
                    },
                    city: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(50),
                    },
                    street: {
                        required,
                        minLength: minLength(3),
                        maxLength: maxLength(50),
                    },
                    house: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(6),
                    },
                    flat: {
                        required,
                        minLength: minLength(1),
                        maxLength: maxLength(6),
                    },
                    user_comment: {
                        minLength: minLength(5),
                        maxLength: maxLength(300),
                    },
                },
            };
        }
    },
    components: {
        deliveryNovaPoshta,
        AdvancedSearch,
        mainSelect,
        privateData,
        typeDelivery,
        typePayment,
        itemInBasket,
        agentClientData,
    },
    directives: {
        onClickaway: onClickaway,
    },
    watch: {
        $route() {
            this.changeShowOrder(false);
        },
        user() {
            if (this.user) {
                this.setData();
            }
        },
    },
    created() {
        if (this.enteredCode) {
            this.isValidCode = true;
        }
        // console.log(this.basket);
        // this.fetchAgentClients().then(() => {
        //   console.log(this.agentClients);
        // })
        if (!this.deliveryMethodsList) {
            this.fetchDeliveryList().then(() => {
                this.payload.delivery = this.deliveryMethodsList.methods[0];
            });
        } else {
            this.payload.delivery = this.deliveryMethodsList.methods[0];
        }
        if (!this.paymentMethodsList) {
            this.fetchPaymentList().then(() => {
                this.payload.payment = this.paymentMethodsList[0];
            });
        } else {
            this.payload.payment = this.paymentMethodsList[0];
        }

        if (this.isAuthenticated && this.user.agent_status) {
            // this.fetchAgentClients()
            this.setData();
            this.agentFlow = true;
        } else {
            // this.setDataNonAuth();
            this.agentFlow = false;
        }
    },
    mounted() {},
    computed: {
        ...mapGetters({
            showOrder: "basket/showOrder",
            basket: "basket/basket",
            count: "basket/count",
            countBasketItems: "basket/countBasketItems",
            list: "profile/user",
            deliveryMethodsList: "deliveryMethods/deliveryMethodsList",
            deliveryMethodsListLoading: "deliveryMethods/deliveryMethodsListLoading",
            paymentMethodsList: "paymentMethods/paymentMethodsList",
            paymentMethodsListLoading: "paymentMethods/paymentMethodsListLoading",
            userInfo: "order/userInfo",
            userAddress: "order/userAddress",
            isAuthenticated: "auth/isAuthenticated",
            user: "profile/user",
            orderLoading: "basket/orderLoading",
            sendBasketLoading: "basket/basketLoading",
            orderResult: "basket/orderResult",
            isOrderLoading: "payment/isOrderLoading",
            invoiceResult: "payment/invoiceResult",
            isInvoiceLoading: "payment/isInvoiceLoading",
            transactionResult: "payment/transactionResult",
            isTransactionLoading: "payment/isTransactionLoading",
            agentClients: "profile/agentClients",
            step: `order/buyFlow`,
            enteredCode: "basket/enteredCode",
        }),

        getClients() {
            const clients = [];
            let data = "";
            for (let i in this.agentClients) {
                data =
                    this.agentClients[i].id +
                    " " +
                    this.agentClients[i].name +
                    " " +
                    this.agentClients[i].second_name +
                    " " +
                    this.agentClients[i].phone;
                clients.push(data);
                // console.log('test', this.agentClients[i].id)
            }
            return clients;
        },
        totalAmount() {
            return this.basket.reduce((accumulator, currentValue) => {
                let totalSum =
                    accumulator +
                    (currentValue.discount_price ? currentValue.discount_price : currentValue.price) *
                        currentValue.select_count;
                return totalSum;
            }, 0);
        },
        totalAmountWithDelivery() {
            return this.totalAmount - this.amountWithDiscount;
        },
        amountWithDiscount() {
            return this.basket.reduce((sum, item) => {
                const price = item.discount_price || item.min_price;
                if (!item.apply_promocode) return sum + item.price * item.select_count;
                return sum + price * item.select_count;
            }, 0);
        },
        totalSum() {
            return this.basket.reduce((accumulator, currentValue) => {
                return accumulator + currentValue.price * currentValue.select_count;
            }, 0);
        },
        cityErrors() {
            let error = [];
            if (!this.$v.payload.city.$dirty) {
                return error;
            }
            if (!this.$v.payload.city.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.city.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.city.minLength) {
                error.push(this.$t("validationMin").replace(":count", 3));
            }
            if (this.validationErrors.city) {
                this.validationErrors.city.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        streetErrors() {
            let error = [];
            if (!this.$v.payload.street.$dirty) {
                return error;
            }
            if (!this.$v.payload.street.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.street.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.street.minLength) {
                error.push(this.$t("validationMin").replace(":count", 3));
            }
            if (this.validationErrors.street) {
                this.validationErrors.street.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        houseErrors() {
            let error = [];
            if (!this.$v.payload.house.$dirty) {
                return error;
            }
            if (!this.$v.payload.house.maxLength) {
                error.push(this.$t("validationMax") + " 6");
            }
            if (!this.$v.payload.house.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.house.minLength) {
                error.push(this.$t("validationMin").replace(":count", 1));
            }
            if (this.validationErrors.house) {
                this.validationErrors.house.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        flatErrors() {
            let error = [];
            if (!this.$v.payload.flat.$dirty) {
                return error;
            }
            if (!this.$v.payload.flat.maxLength) {
                error.push(this.$t("validationMax") + " 6");
            }
            if (!this.$v.payload.flat.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.flat.minLength) {
                error.push(this.$t("validationMin").replace(":count", 1));
            }
            if (this.validationErrors.flat) {
                this.validationErrors.flat.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        userCommentErrors() {
            let error = [];
            if (!this.$v.payload.user_comment.$dirty) {
                return error;
            }
            if (!this.$v.payload.user_comment.maxLength) {
                error.push(this.$t("validationMax") + " 300");
            }
            if (!this.$v.payload.user_comment.minLength) {
                error.push(this.$t("validationMin") + " 5");
            }
            if (this.validationErrors.user_comment) {
                this.validationErrors.user_comment.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        secondNameErrors() {
            let error = [];
            if (!this.$v.payload.second_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.second_name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.second_name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (!this.$v.payload.second_name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (this.validationErrors.second_name) {
                this.validationErrors.second_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        lastNameErrors() {
            let error = [];
            if (!this.$v.payload.last_name.$dirty) {
                return error;
            }
            if (!this.$v.payload.last_name.maxLength) {
                error.push(this.$t("validationMax").replace(":count", 20));
            }
            if (!this.$v.payload.last_name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.last_name.minLength) {
                error.push(this.$t("validationMin").replace(":count", 3));
            }
            if (this.validationErrors.last_name) {
                this.validationErrors.last_name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        emailErrors() {
            let error = [];
            if (!this.$v.payload.email.$dirty) {
                return error;
            }
            if (!this.$v.payload.email.maxLength) {
                error.push(this.$t("validationMax") + " 50");
            }
            if (!this.$v.payload.email.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.email.email) {
                error.push(this.$t("validationEmail"));
            }
            if (this.validationErrors.email) {
                this.validationErrors.email.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationLengthPhone"));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        disableButton() {
            if (this.payload.delivery.id === 2) {
                this.setDataClient();
                if (
                    this.payload.name === "" ||
                    this.payload.second_name === "" ||
                    this.payload.email === "" ||
                    this.payload.phone === ""
                ) {
                    return true;
                }
                return false;
            }
            if (this.payload.delivery.id === 1) {
                if (
                    this.payload.name === "" ||
                    this.payload.second_name === "" ||
                    this.payload.email === "" ||
                    this.payload.phone === ""
                ) {
                    return true;
                }
                return false;
            }

            if (this.payload.delivery.id === 5) {
                if (
                    !this.userAddress.status ||
                    this.payload.name === "" ||
                    this.payload.second_name === "" ||
                    this.payload.email === "" ||
                    this.payload.phone === ""
                ) {
                    return true;
                }
                return false;
            } else {
                return this.$v.$invalid;
            }
        },
    },
    methods: {
        ...mapActions({
            fetchDeliveryList: `deliveryMethods/GET_DELIVERY_METHODS_LIST`,
            fetchPaymentList: `paymentMethods/GET_PAYMENT_METHODS_LIST`,
            createOrder: `basket/CREATE_ORDER`,
            fetchUserData: `profile/FETCH_USER_DATA`,
            sendBasket: `basket/SEND_BASKET`,
            createInvoice: "payment/CREATE_INVOICE",
            createTransaction: "payment/CREATE_TRANSACTION",
            fetchAgentClients: `profile/GET_AGENT_CLIENTS`,
            fetchFilial: `paymentMethods/GET_DELIVERY_FILIAL`,
        }),
        ...mapMutations({
            changeShowOrder: "basket/CHANGE_SHOW_ORDER",
            remove: "basket/REMOVE_ITEM_FROM_BASKET",
            decrementBasketItem: "basket/DECREMENT_BASKET_LIST_COUNT",
            incrementBasketItem: "basket/INCREMENT_BASKET_LIST_COUNT",
            setCountItem: "basket/SET_BASKET_LIST_COUNT",
            changeUserInfo: "order/CHANGE_USER_INFO",
            resetBasket: "basket/RESET_BASKET",
            reset: "payment/RESET_PAYMENT",
            changePopupConfirmPayment: `payment/CHANGE_POPUP_CONFIRM_PAYMENT`,
            setAgentClients: `profile/SET_AGENT_CLIENTS`,
        }),
        // test() {
        //   // console.log('change')
        // },
        // changeCount(item, count=1){
        //   console.log(item)
        //   if (item.count <= count){
        //     count = item.count
        //   }
        //   if(count <= 0){
        //
        //   }
        //
        //     this.setCountItem({
        //       ...item,
        //       select_count: parseInt(count)
        //     })
        // },
        setValidValue: _.debounce(function(val, index, obj) {
            obj.index = index;
            obj.select_count = parseInt(val);
            // console.log(obj)
            if (parseInt(val)) {
                if (parseInt(val) > 0 && parseInt(val) <= obj.count) {
                    this.setCountItem(obj);
                } else {
                    if (obj.count < parseInt(val)) {
                        this.$nextTick(() => {
                            obj.select_count = obj.count;
                            this.setCountItem(obj);
                        });
                    }
                }
            } else {
                obj.select_count = 1;
                this.setCountItem(obj);
            }
        }, 1000),
        removeItem(item) {
            this.remove(item);
            this.$toasted.success(this.$t("successRemoveBasket"));
            if (!this.countBasketItems) {
                this.close();
            }
        },
        close() {
            if (this.showOrder) {
                this.changeShowOrder(false);
            }
        },
        // createInvoiceLocal() {
        //   const payloadInvoice = new FormData();
        //   payloadInvoice.append('order_id', this.orderResult.id);
        //   this.createInvoice(payloadInvoice).then(() => {
        //     this.$toasted.success(this.$t('createInvoices'));
        //     // console.log(this.invoiceResult);
        //     this.createTransactionLocal();
        //   }).catch(error => {
        //     console.log(error);
        //     if (error.response.status === 422) {
        //       const objErrors = error.response.data.errors;
        //       for (let i in objErrors) {
        //         objErrors[i].forEach(t => {
        //           this.$toasted.error(t)
        //         })
        //       }
        //     }
        //   })  // userInfo:'userInfo'
        // },
        // createTransactionLocal() {
        //   const payloadTransaction = new FormData();
        //   payloadTransaction.append('invoice_id', this.invoiceResult.id);
        //   payloadTransaction.append('amount', this.invoiceResult.value);
        //
        //   this.createTransaction(payloadTransaction).then(() => {
        //     this.$toasted.success(this.$t('successCreateTransaction')).goAway(10000);
        //     this.changePopupConfirmPayment(true);
        //     this.resetBasket();
        //
        //   }).catch(error => {
        //     if (error.response.status === 424) {
        //       const objErrors = error.response.data;
        //       this.$toasted.error(objErrors.message);
        //     }
        //     if (error.response.status === 422) {
        //       const objErrors = error.response.data.errors;
        //       for (let i in objErrors) {
        //         objErrors[i].forEach(t => {
        //           this.$toasted.error(t)
        //         })
        //       }
        //     }
        //   })
        // },
        changeWord(count) {
            let titles = [this.$t("productWord1"), this.$t("productWord2"), this.$t("productWord3")];
            let cases = [2, 0, 1, 1, 1, 2];
            return titles[count % 100 > 4 && count % 100 < 20 ? 2 : cases[count % 10 < 5 ? count % 10 : 5]];
        },
        submit() {
            console.log(33);
            let obj = {};
            if (this.user.agent_status !== 2) {
                this.$v.$touch();
                obj.email = this.payload.email;
                obj.name = this.payload.name;
                obj.second_name = this.payload.second_name;
                obj.last_name = this.payload.last_name;
                obj.delivery_method_id = this.payload.delivery.id;
                obj.payment_method_id = this.payload.payment.id;
                obj.recipient = this.payload.recipient;
                obj.user_comment = this.payload.user_comment;
                obj.need_confirm = this.payload.need_confirm;
                obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                obj.sum = this.totalAmount;
                obj.total_sum = this.totalSum;
            } else {
                this.setDataClient();
                obj.email = this.payload.email;
                obj.name = this.payload.name;
                obj.second_name = this.payload.second_name;
                obj.last_name = this.payload.last_name;
                obj.delivery_method_id = this.payload.delivery.id;
                obj.payment_method_id = this.payload.payment.id;
                obj.recipient = this.payload.recipient;
                obj.user_comment = this.payload.user_comment;
                obj.need_confirm = this.payload.need_confirm;
                obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                obj.sum = this.totalAmount;
                obj.total_sum = this.totalSum;
            }

            if (this.payload.delivery.id === 5) {
                obj.delivery_address = this.userAddress.town + ", " + this.userAddress.department;
            } else if (this.payload.delivery.id === 1) {
                // console.log('first')
                obj.delivery_address = "Самовывоз";
            } else {
                obj.delivery_address =
                    "м." +
                    this.payload.city +
                    ", " +
                    this.payload.street +
                    " " +
                    this.payload.house +
                    "/" +
                    this.payload.flat;
            }

            if (!this.$v.$invalid || this.user.agent_status === 2) {
                this.sendBasket(this.basket)
                    .then(() => {
                        this.createOrder(obj)
                            .then(() => {
                                this.$toasted.success(this.$t("successOrderCreate"));

                                if (this.payload.payment.id === 3) {
                                    this.$toasted.success(this.$t("createInvoices"));
                                    this.createInvoiceLocal();
                                } else {
                                    this.changeShowOrder(false);
                                    this.resetBasket();
                                }
                            })
                            .catch(error => {
                                console.log(error);
                                if (error.response.status === 418) {
                                    this.$toasted.error(error.response.data.message);
                                }
                            });
                    })
                    .catch(error => {
                        console.log(error);
                        if (error.response.status === 418) {
                            this.$toasted.error(error.response.data.message);
                        }
                    });
            }
        },
        // resetForm() {
        //   this.$nextTick(() => {
        //     this.$v.$reset()
        //   })
        // },
        setDataClient() {
            let currentId = this.pickedClient.slice(0, this.pickedClient.indexOf(" "));
            // console.log(currentId)
            for (let i in this.agentClients) {
                // console.log(this.agentClients[i].id);
                if (this.agentClients[i].id === parseInt(currentId)) {
                    this.payload.name = this.agentClients[i].name;
                    this.payload.second_name = this.agentClients[i].second_name;
                    this.payload.last_name = this.agentClients[i].last_name;
                    this.payload.phone = this.agentClients[i].phone;
                    this.payload.street = this.agentClients[i].street;
                    this.payload.house = this.agentClients[i].house;
                    this.payload.flat = this.agentClients[i].flat;
                    this.payload.city = this.agentClients[i].city;
                }
            }
        },
        setData() {
            console.log(this.user.name, this.user.second_name, this.user.last_name, "order");
            this.payload.name = this.user.name;
            this.payload.second_name = this.user.second_name;
            this.payload.last_name = this.user.last_name;
            this.payload.email = this.user.email;
            this.payload.phone = this.user.phone;
            let mainAddress = this.user.addresses.find(main => main.active === 1);
            if (mainAddress) {
                this.payload.street = mainAddress.street;
                this.payload.house = mainAddress.house;
                this.payload.flat = mainAddress.flat;
                this.payload.city = mainAddress.city;
            }
        },
        setDataNonAuth() {
            this.payload.name = this.userInfo.name;
            this.payload.second_name = this.userInfo.second_name;
            this.payload.last_name = this.userInfo.last_name;
            this.payload.email = this.userInfo.email;
            this.payload.phone = this.userInfo.phone;
            this.payload.street = this.userInfo.street;
            this.payload.house = this.userInfo.house;
            this.payload.flat = this.userInfo.flat;
            this.payload.city = this.userInfo.city;
        },
        createInvoiceLocal() {
            const payloadInvoice = new FormData();
            payloadInvoice.append("order_id", this.orderResult.id);
            this.createInvoice(payloadInvoice)
                .then(() => {
                    this.$toasted.success(this.$t("createInvoices"));
                    // console.log(this.invoiceResult);
                    this.createTransactionLocal();
                })
                .catch(error => {
                    console.log(error);
                    if (error.response.status === 422) {
                        const objErrors = error.response.data.errors;
                        for (let i in objErrors) {
                            objErrors[i].forEach(t => {
                                this.$toasted.error(t);
                            });
                        }
                    }
                });
        },
        createTransactionLocal() {
            const payloadTransaction = new FormData();
            payloadTransaction.append("invoice_id", this.invoiceResult.id);
            payloadTransaction.append("amount", this.invoiceResult.value);

            this.createTransaction(payloadTransaction)
                .then(() => {
                    this.$toasted.success(this.$t("successCreateTransaction")).goAway(10000);
                    this.changePopupConfirmPayment(true);
                    this.resetBasket();
                })
                .catch(error => {
                    if (error.response.status === 424) {
                        const objErrors = error.response.data;
                        this.$toasted.error(objErrors.message);
                    }
                    if (error.response.status === 422) {
                        const objErrors = error.response.data.errors;
                        for (let i in objErrors) {
                            objErrors[i].forEach(t => {
                                this.$toasted.error(t);
                            });
                        }
                    }
                });
        },
        next() {
            this.stage += 1;
        },
    },
    // destroyed() {
    //   this.resetForm();
    // }
};
